import { render, staticRenderFns } from "./Voices.vue?vue&type=template&id=980832e2&"
import script from "./Voices.vue?vue&type=script&lang=js&"
export * from "./Voices.vue?vue&type=script&lang=js&"
import style0 from "./Voices.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports